import { c as _c } from "react/compiler-runtime";
import md5 from 'md5';
import { clearTempUserIdCookie, setUserAccessTokenCookie, setUserCookie, setUserRefreshTokenCookie } from 'commons/localStorage';
import useUserRawValue from 'global-state/user/useUserRawValue';
import useSetUser from 'global-state/user/useSetUser';
import useIdentifyFacebookUser from './useIdentifyFacebookUser';
import useRefetchAfterAuthChange from './useRefetchAfterAuthChange';
const useSetAuthTokenAndUser = () => {
  const $ = _c(5);
  const userPrevious = useUserRawValue();
  const setUser = useSetUser();
  const identifyFacebookUser = useIdentifyFacebookUser();
  const refetchAfterAuthChange = useRefetchAfterAuthChange();
  let t0;
  if ($[0] !== identifyFacebookUser || $[1] !== refetchAfterAuthChange || $[2] !== setUser || $[3] !== userPrevious) {
    t0 = async (t1, t2) => {
      const {
        access_token,
        email,
        first_name,
        group_id,
        id,
        is_designer,
        is_impersonate,
        last_name,
        refresh_token,
        user_discount
      } = t1;
      const shouldRefetch = t2 === undefined ? true : t2;
      const user = {
        ...(userPrevious ?? {}),
        email,
        first_name,
        group_id,
        id,
        is_designer,
        is_impersonate: !!is_impersonate,
        last_name,
        user_discount
      };
      clearTempUserIdCookie();
      setUserAccessTokenCookie(access_token);
      setUserRefreshTokenCookie(refresh_token);
      if (access_token) {
        setUserCookie({
          ...user,
          customerId: user.id,
          firstName: user.first_name,
          lastName: user.last_name,
          email: user.email,
          hashedEmail: user.email ? md5(user.email) : ""
        });
      }
      setUser(user);
      identifyFacebookUser({
        email,
        firstName: first_name,
        lastName: last_name,
        userId: id
      });
      if (shouldRefetch) {
        refetchAfterAuthChange();
      }
    };
    $[0] = identifyFacebookUser;
    $[1] = refetchAfterAuthChange;
    $[2] = setUser;
    $[3] = userPrevious;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const setAuthTokenAndUser = t0;
  return setAuthTokenAndUser;
};
export default useSetAuthTokenAndUser;